export function isCodeInRange(codeRange, code) {
    if (codeRange === "0") {
        return true;
    }
    if (codeRange === code.toString()) {
        return true;
    }
    else {
        const codeString = code.toString();
        if (codeString.length != codeRange.length) {
            return false;
        }
        for (let i = 0; i < codeString.length; i++) {
            if (codeRange.charAt(i) != "X" && codeRange.charAt(i) != codeString.charAt(i)) {
                return false;
            }
        }
        return true;
    }
}
export async function retry(fn, n = 1, codesToIgnore = [], maxDelay, initialDelay = 100, jitter = false) {
    for (let i = 0; i < n; i++) {
        try {
            return await fn();
        }
        catch (error) {
            if (error.code && codesToIgnore.includes(error.code)) {
                throw error;
            }
            if (i == n - 1) {
                throw error;
            }
            const exponentialDelay = initialDelay * 2 ** i;
            const cappedDelay = maxDelay === undefined ? exponentialDelay : Math.min(exponentialDelay, maxDelay);
            const delay = jitter ? cappedDelay / 2 + Math.random() * cappedDelay / 2 : cappedDelay;
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
    throw new RangeError("Reached unreachable retry code");
}
